// extracted by mini-css-extract-plugin
export default {"link":"style_link__F3Z9Q","centerGrid":"style_centerGrid__-kZ02","img":"style_img__8YTSq","namegame":"style_namegame__QNziK"};